import React, { useRef } from 'react';
import { useConfirm } from '../../context/ConfirmContext';

export const CONFIRM_CLICK_LABEL = 'Emin misiniz?';

const labelFromChildren = (children) => {
  if (typeof children === 'string' || typeof children === 'number') {
    return String(children);
  }
  return 'bu işlem';
};

/**
 * Basınca 2 adımlı onay penceresi açar; onaylanınca asıl işlemi çalıştırır.
 * type="submit" ise onay sonrası formu gönderir.
 */
const ConfirmClickButton = ({
  onConfirm,
  className,
  confirmClassName: _confirmClassName,
  children,
  confirmLabel = 'Evet, Onayla',
  confirmTitle,
  confirmDescription,
  confirmStep2Description,
  confirmTone = 'default',
  icon: Icon,
  iconSize = 16,
  iconClassName = 'shrink-0',
  labelClassName,
  role,
  type = 'button',
  disabled = false,
  title,
}) => {
  const requestConfirm = useConfirm();
  const buttonRef = useRef(null);

  const handleClick = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (disabled) return;

    const actionLabel = labelFromChildren(children);
    const ok = await requestConfirm({
      title: confirmTitle || 'İşlemi onayla',
      step1Description:
        confirmDescription ||
        `“${actionLabel}” işlemini yapmak istediğinize emin misiniz?`,
      step2Description:
        confirmStep2Description ||
        'Son onay: işlemi uygulamak için tekrar onaylayın.',
      confirmLabel,
      tone: confirmTone,
    });
    if (!ok) return;

    const form = buttonRef.current?.form;
    if (type === 'submit' && form) {
      // iOS 15 ve öncesinde requestSubmit yok
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else if (form.reportValidity?.() !== false) {
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
      return;
    }
    await onConfirm?.(event);
  };

  return (
    <button
      ref={buttonRef}
      type={type === 'submit' ? 'button' : type}
      role={role}
      disabled={disabled}
      title={title}
      onClick={handleClick}
      className={className}
      data-confirm-trigger="true"
    >
      {Icon ? <Icon size={iconSize} className={iconClassName} /> : null}
      {children != null && children !== '' && (
        <span className={labelClassName}>{children}</span>
      )}
    </button>
  );
};

export default ConfirmClickButton;
